export function isFunction(v) {
  return typeof v === 'function';
}

export function isString(v) {
  return typeof v === 'string';
}

export function isEmptyString(v) {
  return typeof v === 'string' && v.length === 0;
}

export function isObject(v) {
  return Object.prototype.toString.call(v) === '[object Object]';
}

export function isArray(v) {
  return Object.prototype.toString.call(v) === '[object Array]';
}

export function isFormData(v) {
  return Object.prototype.toString.call(v) === '[object FormData]';
}

export function isPositiveInteger(v) {
  return Number.isInteger(v) && v > -1;
}
